var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3200_60914)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0029 10.001C20.0029 10.001 16.2529 3.12598 10.0029 3.12598C3.75293 3.12598 0.00292969 10.001 0.00292969 10.001C0.00292969 10.001 3.75293 16.876 10.0029 16.876C16.2529 16.876 20.0029 10.001 20.0029 10.001ZM1.46918 10.001C2.07357 9.08238 2.76873 8.22683 3.54418 7.44723C5.15293 5.83598 7.35293 4.37598 10.0029 4.37598C12.6529 4.37598 14.8517 5.83598 16.4629 7.44723C17.2384 8.22683 17.9335 9.08238 18.5379 10.001C18.4654 10.1097 18.3854 10.2297 18.2942 10.361C17.8754 10.961 17.2567 11.761 16.4629 12.5547C14.8517 14.166 12.6517 15.626 10.0029 15.626C7.35293 15.626 5.15418 14.166 3.54293 12.5547C2.76749 11.7751 2.07358 10.9196 1.46918 10.001Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0029 6.87598C9.17413 6.87598 8.37927 7.20522 7.79322 7.79127C7.20717 8.37732 6.87793 9.17218 6.87793 10.001C6.87793 10.8298 7.20717 11.6246 7.79322 12.2107C8.37927 12.7967 9.17413 13.126 10.0029 13.126C10.8317 13.126 11.6266 12.7967 12.2126 12.2107C12.7987 11.6246 13.1279 10.8298 13.1279 10.001C13.1279 9.17218 12.7987 8.37732 12.2126 7.79127C11.6266 7.20522 10.8317 6.87598 10.0029 6.87598ZM5.62793 10.001C5.62793 8.84065 6.08887 7.72786 6.90934 6.90738C7.72981 6.08691 8.84261 5.62598 10.0029 5.62598C11.1633 5.62598 12.276 6.08691 13.0965 6.90738C13.917 7.72786 14.3779 8.84065 14.3779 10.001C14.3779 11.1613 13.917 12.2741 13.0965 13.0946C12.276 13.915 11.1633 14.376 10.0029 14.376C8.84261 14.376 7.72981 13.915 6.90934 13.0946C6.08887 12.2741 5.62793 11.1613 5.62793 10.001Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3200_60914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.b3f767b77945bae458b857813363c190.svg";
export { ForwardRef as ReactComponent };